// @ts-strict-ignore
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Box, Illustration } from '@node-space/ui-components'
import { HeaderCTA } from 'components/header/HeaderCTA'
import LoginPageLayout from 'components/layout/LoginPageLayout'
import { PathNames } from 'constants/General'
import {
  AmplitudeEvent,
  AmplitudeEventAction,
  AmplitudeEventCategory,
} from 'utils/amplitude/amplitudeEvents'
import { isSandbox, isTest } from 'utils/environment'
import { changeLocationHref } from 'utils/location'
import { Amp } from 'utils/tracker'

const CONTACT_SALES_URL = process.env.CONTACT_SALES_URL

export const CTAGetStarted = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  useEffect(() => {
    Amp.track(AmplitudeEvent.ONBOARDING_LOAD_CTA_GET_STARTED, {
      category: AmplitudeEventCategory.ONBOARDING,
      action: AmplitudeEventAction.LOAD,
    })
  }, [])

  const getInTouchClick = () => {
    Amp.track(AmplitudeEvent.ONBOARDING_CLICK_CONTINUE_CTA_GET_STARTED, {
      category: AmplitudeEventCategory.ONBOARDING,
      action: AmplitudeEventAction.CLICK,
      experimentID: 'EXP-2-ONB-EXPERT',
    })

    changeLocationHref(CONTACT_SALES_URL)
  }

  const onSignUpSandboxClick = () => {
    Amp.track(AmplitudeEvent.ONBOARDING_CLICK_CONTINUE_CTA_GET_STARTED, {
      category: AmplitudeEventCategory.ONBOARDING,
      action: AmplitudeEventAction.CLICK,
      experimentID: 'EXP-2-ONB-SANDBOX-SIGNUP',
    })

    if (isSandbox || isTest) {
      navigate(PathNames.DEVX_SIGNUP_URL)
    } else {
      changeLocationHref(`https://app.sandbox.bvnk.com${PathNames.DEVX_SIGNUP_URL}`)
    }
  }

  const cards = [
    {
      icon: <Illustration name="SpeakToExpert" />,
      label: t('ctaGetStarted.speakToExpert'),
      description: t('ctaGetStarted.speakToExpertDescription'),
      onclick: getInTouchClick,
      testId: 'get-in-touch-button',
    },
    {
      icon: <Illustration name="DeveloperSandbox" />,
      label: t('ctaGetStarted.developerSandbox'),
      description: t('ctaGetStarted.developerSandboxDescription'),
      onclick: onSignUpSandboxClick,
      testId: 'sign-up-sandbox-button',
    },
  ]

  return (
    <>
      <LoginPageLayout
        title={t('ctaGetStarted.banner')}
        description={<p className="mt-4">{t('ctaGetStarted.description')}</p>}
        headerRightContent={
          <HeaderCTA
            helpText={`${t('alreadySignedUp')}`}
            buttonText={`${t('logIn')}`}
            buttonUrl={PathNames.LOGIN}
          />
        }
        hasFooter
      >
        <Box
          flex
          flexCol
          gap={32}
          paddingT={16}
          paddingB={32}
          justify="center"
          width="full"
          align="center"
          className="md:flex-row md:items-stretch md:gap-x-[74px]"
        >
          {cards.map(card => (
            <Box
              key={card.label}
              flexCol
              justify="center"
              gapY={20}
              paddingX={24}
              paddingY={32}
              className="bg-background-elevated border border-stroke-static md:w-[320px] h-[350px] shadow-interactive cursor-pointer"
              borderRadius={8}
              onClick={card.onclick}
              testId={card.testId}
            >
              <Box width="full" flex centerChildren>
                {card.icon}
              </Box>
              <Box flexCol gapY={8} className="md:gap-y-5">
                <h3 className="text-center text-foreground-prominent text-h3">{card.label}</h3>
                <p className="text-center text-foreground-subdued text-body-regular">
                  {card.description}
                </p>
              </Box>
            </Box>
          ))}
        </Box>
      </LoginPageLayout>
    </>
  )
}
